module.exports = __webpack_public_path__ + "static/media/campaign.edc53943.png";